import { SweetAlertService } from './../../../../core/services/utils/sweet-alert.service';

import { Component, OnInit } from '@angular/core';
declare var JitsiMeetExternalAPI: any;

import { EmitService } from './../../../../core/services/utils/emit.service';
import { ModalService } from 'src/app/core/services/utils/modal.service';
import { LocalService } from './../../../../core/services/storage/local.service';

@Component({
  selector: 'app-modal-atencion-remota',
  templateUrl: './modal-atencion-remota.component.html',
  styleUrls: ['./modal-atencion-remota.component.css']
})
export class ModalAtencionRemotaComponent implements OnInit {
  idTurno: any;
  ejecutivo: any;
  api: any;
  escritorio: any;
  turno: any = {};

  constructor(
    private localSecureService: LocalService,
    private modalService: ModalService,
    private emit: EmitService,
    private sweetAlertService: SweetAlertService
  ) { }

  ngOnInit(): void {
    this.escritorio = this.localSecureService.getValue('escritorio');
    this.turno = this.localSecureService.getValue('turno');
    this.lazarMeet(this.idTurno, this.ejecutivo);
  }

  /* Hacer llamada para atención remota con Jitsi */
  lazarMeet(idTurno: string, nombre: string) {
    const myOverwrite =
    {
      'TOOLBAR_BUTTONS': [
        'microphone', 'camera',  'desktop', 'closedcaptions', 'fullscreen', 'fodeviceselection',
        'profile', 'etherpad', 'tileview', 'help'
      ],
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        MOBILE_APP_PROMO: false, SHOW_CHROME_EXTENSION_BANNER: false
    };

    const options = {
      roomName: idTurno,
      width: 700,
      height: 350,
      parentNode: document.querySelector('#llamadaJitsi'),
      configOverwrite: {
        prejoinPageEnabled: false,
        disableDeepLinking: true,
        startWithAudioMuted: false,
        resolution: 720,
        constraints: {
          video: {
            aspectRatio: 16 / 9,
            height: {
              ideal: 720,
              max: 720,
              min: 240
            }
          }
        },
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        MOBILE_APP_PROMO: false, SHOW_CHROME_EXTENSION_BANNER: false
      },
      interfaceConfigOverwrite: myOverwrite, prejoinPageEnabled: false,
      resolution: 720,
      constraints: {
        video: {
          aspectRatio: 16 / 9,
          height: {
            ideal: 720,
            max: 720,
            min: 240
          }
        }
      },
      UNSUPPORTED_BROWSERS: [],
      OPTIMAL_BROWSERS: ['chrome', 'firefox', 'safari'],
      enableNoisyMicDetection: true,
      SETTINGS_SECTIONS: ['devices', 'language'],
      chromeExtensionBanner: {
        // The chrome extension to be installed address
        url: 'https://chrome.google.com/webstore/detail/jitsi-meetings/' + idTurno,
        // Extensions info which allows checking if they are installed or not
        chromeExtensionsInfo: [
          {
            id: idTurno,
            path: 'jitsi-logo-48x48.png'
          }
        ]
      },
      userInfo: {
        displayName: nombre
      }
    }
    this.api = new JitsiMeetExternalAPI('jitsimeet.t-salud.com', options);

    this.api.addEventListeners({
      participantLeft: this.handleParticipantLeft,
    });

  }

  handleParticipantLeft = (arg: any) => {
    this.sweetAlertService.swalFin();
    this.closeModal();
  }

  terminarAtencion() {
    this.closeModal();
    this.emit.enviarData('finAtencion');
  }

  closeModal(): void {
    this.modalService.closeModal();
  }
}
